export default {
    // @文字列処理
    '文字数': {
        type: 'func',
        josi: [['の']],
        pure: true,
        fn: function (v) {
            if (!Array.from) {
                return String(v).length;
            }
            if (typeof v !== 'string') {
                v = String(v);
            }
            // Unicodeのサロゲートペアを考慮して文字数をカウント #1954 を参照
            return Array.from(v).length;
        }
    },
    '何文字目': {
        type: 'func',
        josi: [['で', 'の'], ['が']],
        pure: true,
        fn: function (s, a) {
            // Unicodeのサロゲートペアを考慮して、文字列を検索 #1954 を参照
            // return String(s).indexOf(a) + 1 // サロゲートペアを無視した場合
            const strArray = Array.from(s);
            const searchArray = Array.from(a);
            for (let i = 0; i < strArray.length; i++) {
                if (strArray.slice(i, i + searchArray.length).join('') === searchArray.join('')) {
                    return i + 1;
                }
            }
            return 0;
        }
    },
    'CHR': {
        type: 'func',
        josi: [['の']],
        pure: true,
        fn: function (v) {
            // 数値のとき
            if (typeof v === 'number') {
                if (!String.fromCodePoint) {
                    return String.fromCharCode(v);
                }
                return String.fromCodePoint(v);
            }
            // 配列のとき
            const res = [];
            for (const s of v) {
                if (!String.fromCodePoint) {
                    res.push(String.fromCharCode(s));
                }
                else {
                    res.push(String.fromCodePoint(s));
                }
            }
            return res;
        }
    },
    'ASC': {
        type: 'func',
        josi: [['の']],
        pure: true,
        fn: function (v) {
            if (typeof v === 'string') {
                if (!String.prototype.codePointAt) {
                    return String(v).charCodeAt(0);
                }
                return String(v).codePointAt(0) || 0;
            }
            const res = [];
            for (const s of v) {
                if (!String.prototype.codePointAt) {
                    res.push(String(s).charCodeAt(0));
                }
                else {
                    res.push(String(s).codePointAt(0) || 0);
                }
            }
            return res;
        }
    },
    '文字挿入': {
        type: 'func',
        josi: [['で', 'の'], ['に', 'へ'], ['を']],
        pure: true,
        fn: function (s, i, a) {
            if (i <= 0) {
                i = 1;
            }
            const strArray = Array.from(s);
            strArray.splice(i - 1, 0, a);
            return strArray.join('');
        }
    },
    '文字検索': {
        type: 'func',
        josi: [['で', 'の'], ['から'], ['を']],
        pure: true,
        fn: function (s, a, b) {
            // サロゲートペアを考慮して文字列を検索する
            // return String(s).indexOf(b, a - 1) + 1
            if (a <= 0) {
                a = 1;
            }
            const strArray = Array.from(s);
            const searchArray = Array.from(b);
            // Unicode単位で検索
            for (let i = a - 1; i < strArray.length; i++) {
                if (strArray.slice(i, i + searchArray.length).join('') === searchArray.join('')) {
                    // 合致した
                    return i + 1;
                }
            }
            return 0;
        }
    },
    '追加': {
        type: 'func',
        josi: [['で', 'に', 'へ'], ['を']],
        pure: true,
        fn: function (s, a) {
            if (s instanceof Array) {
                s.push(a);
                return s;
            }
            return String(s) + String(a);
        }
    },
    '一行追加': {
        type: 'func',
        josi: [['で', 'に', 'へ'], ['を']],
        pure: true,
        fn: function (s, a) {
            if (s instanceof Array) {
                s.push(a);
                return s;
            }
            return String(s) + String(a) + '\n';
        }
    },
    '連結': {
        type: 'func',
        josi: [['と', 'を']],
        pure: true,
        isVariableJosi: true,
        fn: function (...a) {
            a.pop(); // NakoSystemを取り除く
            return a.join('');
        }
    },
    '文字列連結': {
        type: 'func',
        josi: [['と', 'を']],
        pure: true,
        isVariableJosi: true,
        fn: function (...a) {
            a.pop(); // NakoSystemを取り除く
            return a.join('');
        }
    },
    '文字列分解': {
        type: 'func',
        josi: [['を', 'の', 'で']],
        pure: true,
        fn: function (v) {
            if (!Array.from) {
                return String(v).split('');
            }
            return Array.from(v);
        }
    },
    'リフレイン': {
        type: 'func',
        josi: [['を', 'の'], ['で']],
        pure: true,
        fn: function (v, cnt) {
            let s = '';
            for (let i = 0; i < cnt; i++) {
                s += String(v);
            }
            return s;
        }
    },
    '出現回数': {
        type: 'func',
        josi: [['で'], ['の']],
        pure: true,
        fn: function (s, a) {
            s = '' + s;
            a = '' + a;
            return s.split(a).length - 1;
        }
    },
    'MID': {
        type: 'func',
        josi: [['で', 'の'], ['から'], ['を']],
        pure: true,
        fn: function (s, a, cnt, sys) {
            return sys.__exec('文字抜出', [s, a, cnt]);
        }
    },
    '文字抜出': {
        type: 'func',
        josi: [['で', 'の'], ['から'], ['を', '']],
        pure: true,
        fn: function (s, a, cnt) {
            // 引数の型チェック #1995
            if (typeof a === 'string') {
                a = parseInt(a);
            }
            if (typeof cnt === 'string') {
                cnt = parseInt(cnt);
            }
            // もし、cntが0以下なら空文字を返す
            if (cnt <= 0) {
                return '';
            }
            // サロゲートペアを考慮した処理を行う
            const strArray = Array.from(s);
            // もし、aの値が0未満の時は後ろからa文字目からcnt文字を抽出
            if (a < 0) {
                a = strArray.length + a + 1;
                if (a < 0) {
                    a = 1;
                }
            }
            return strArray.slice(a - 1, a + cnt - 1).join('');
        }
    },
    'LEFT': {
        type: 'func',
        josi: [['の', 'で'], ['だけ']],
        pure: true,
        fn: function (s, cnt, sys) {
            return sys.__exec('文字左部分', [s, cnt]);
        }
    },
    '文字左部分': {
        type: 'func',
        josi: [['の', 'で'], ['だけ', '']],
        pure: true,
        fn: function (s, cnt) {
            // return (String(s).substring(0, cnt))
            // サロゲートペアを考慮
            const strArray = Array.from(s);
            return strArray.slice(0, cnt).join('');
        }
    },
    'RIGHT': {
        type: 'func',
        josi: [['の', 'で'], ['だけ']],
        pure: true,
        fn: function (s, cnt, sys) {
            return sys.__exec('文字右部分', [s, cnt]);
        }
    },
    '文字右部分': {
        type: 'func',
        josi: [['の', 'で'], ['だけ', '']],
        pure: true,
        fn: function (s, cnt) {
            // return (s.substring(s.length - cnt, s.length))
            // サロゲートペアを考慮
            const strArray = Array.from(s);
            let index = strArray.length - cnt;
            if (index < 0) {
                index = 0;
            }
            return strArray.slice(index, strArray.length).join('');
        }
    },
    '区切': {
        type: 'func',
        josi: [['の', 'を'], ['で']],
        pure: true,
        fn: function (s, a) {
            return ('' + s).split('' + a);
        }
    },
    '文字列分割': {
        type: 'func',
        josi: [['を'], ['で']],
        pure: true,
        fn: function (s, a) {
            s = '' + s;
            a = '' + a;
            const i = s.indexOf(a);
            if (i < 0) {
                return [s];
            }
            return [s.substring(0, i), s.substring(i + a.length)];
        }
    },
    '切取': {
        type: 'func',
        josi: [['から', 'の'], ['まで', 'を']],
        pure: true,
        fn: function (s, a, sys) {
            s = String(s);
            const i = s.indexOf(a);
            if (i < 0) {
                sys.__setSysVar('対象', '');
                return s;
            }
            sys.__setSysVar('対象', s.substring(i + a.length));
            return s.substring(0, i);
        }
    },
    '範囲切取': {
        type: 'func',
        josi: [['で', 'の'], ['から'], ['まで', 'を']],
        pure: true,
        fn: function (s, a, b, sys) {
            s = String(s);
            let mae = '';
            let usiro = '';
            const i = s.indexOf(a);
            if (i < 0) {
                sys.__setSysVar('対象', s);
                return '';
            }
            mae = s.substring(0, i);
            const subS = s.substring(i + a.length);
            const j = subS.indexOf(b);
            if (j < 0) {
                sys.__setSysVar('対象', mae);
                return subS;
            }
            const result = subS.substring(0, j);
            usiro = subS.substring(j + b.length);
            sys.__setSysVar('対象', mae + usiro);
            return result;
        }
    },
    '文字削除': {
        type: 'func',
        josi: [['の'], ['から'], ['だけ', 'を', '']],
        pure: true,
        fn: function (s, a, b) {
            // サロゲートペアを考慮
            const strArray = Array.from(s);
            strArray.splice(a - 1, b);
            return strArray.join('');
        }
    },
    '文字始': {
        type: 'func',
        josi: [['が'], ['で', 'から']],
        pure: true,
        fn: function (s, a) {
            return s.startsWith(a);
        }
    },
    '文字終': {
        type: 'func',
        josi: [['が'], ['で']],
        pure: true,
        fn: function (s, a) {
            return s.endsWith(a);
        }
    },
    '出現': {
        type: 'func',
        josi: [['に', 'で'], ['が']],
        pure: true,
        fn: function (s, a) {
            if (typeof (s) === 'string') {
                return s.includes(a);
            }
            if (s instanceof Array) {
                return s.includes(a);
            }
            const ss = String(s);
            return ss.includes(a);
        }
    },
    // @置換・トリム
    '置換': {
        type: 'func',
        josi: [['の', 'で'], ['を', 'から'], ['に', 'へ']],
        pure: true,
        fn: function (s, a, b) {
            return String(s).split(a).join(b);
        }
    },
    '単置換': {
        type: 'func',
        josi: [['の', 'で'], ['を'], ['に', 'へ']],
        pure: true,
        fn: function (s, a, b) {
            // replaceは最初の一度だけ置換する
            return String(s).replace(a, b);
        }
    },
    'トリム': {
        type: 'func',
        josi: [['の', 'を']],
        pure: true,
        fn: function (s) {
            return String(s).replace(/^\s+/, '').replace(/\s+$/, '');
        }
    },
    '空白除去': {
        type: 'func',
        josi: [['の', 'を']],
        pure: true,
        fn: function (s) {
            return String(s).replace(/^\s+/, '').replace(/\s+$/, '');
        }
    },
    '右トリム': {
        type: 'func',
        josi: [['の', 'を']],
        pure: true,
        fn: function (s) {
            return String(s).replace(/\s+$/, '');
        }
    },
    '左トリム': {
        type: 'func',
        josi: [['の', 'を']],
        pure: true,
        fn: function (s) {
            return String(s).replace(/^\s+/, '');
        }
    },
    '末尾空白除去': {
        type: 'func',
        josi: [['の', 'を']],
        pure: true,
        fn: function (s) {
            return String(s).replace(/\s+$/, '');
        }
    },
    // @文字変換
    '大文字変換': {
        type: 'func',
        josi: [['の', 'を']],
        pure: true,
        fn: function (s) {
            return String(s).toUpperCase();
        }
    },
    '小文字変換': {
        type: 'func',
        josi: [['の', 'を']],
        pure: true,
        fn: function (s) {
            return String(s).toLowerCase();
        }
    },
    '平仮名変換': {
        type: 'func',
        josi: [['の', 'を']],
        pure: true,
        fn: function (s) {
            const kanaToHira = (str) => {
                return String(str).replace(/[\u30a1-\u30f6]/g, function (m) {
                    const chr = m.charCodeAt(0) - 0x60;
                    return String.fromCharCode(chr);
                });
            };
            return kanaToHira('' + s);
        }
    },
    'カタカナ変換': {
        type: 'func',
        josi: [['の', 'を']],
        pure: true,
        fn: function (s) {
            const hiraToKana = (str) => {
                return String(str).replace(/[\u3041-\u3096]/g, function (m) {
                    const chr = m.charCodeAt(0) + 0x60;
                    return String.fromCharCode(chr);
                });
            };
            return hiraToKana('' + s);
        }
    },
    '英数全角変換': {
        type: 'func',
        josi: [['の', 'を']],
        pure: true,
        fn: function (s) {
            return String(s).replace(/[A-Za-z0-9]/g, function (v) {
                return String.fromCharCode(v.charCodeAt(0) + 0xFEE0);
            });
        }
    },
    '英数半角変換': {
        type: 'func',
        josi: [['の', 'を']],
        pure: true,
        fn: function (s) {
            return String(s).replace(/[Ａ-Ｚａ-ｚ０-９]/g, function (v) {
                return String.fromCharCode(v.charCodeAt(0) - 0xFEE0);
            });
        }
    },
    '英数記号全角変換': {
        type: 'func',
        josi: [['の', 'を']],
        pure: true,
        fn: function (s) {
            return String(s).replace(/[\x20-\x7E]/g, function (v) {
                if (v === ' ') {
                    return '　';
                } // 半角スペース(0x20)を全角スペース(U+3000)に
                return String.fromCharCode(v.charCodeAt(0) + 0xFEE0);
            });
        }
    },
    '英数記号半角変換': {
        type: 'func',
        josi: [['の', 'を']],
        pure: true,
        fn: function (s) {
            return String(s).replace(/[\u3000\uFF00-\uFF5F]/g, function (v) {
                if (v === '　') {
                    return ' ';
                } // 全角スペース(U+3000)を半角スペース(U+0020)
                return String.fromCharCode(v.charCodeAt(0) - 0xFEE0);
            });
        }
    },
    'カタカナ全角変換': {
        type: 'func',
        josi: [['の', 'を']],
        pure: true,
        fn: function (s, sys) {
            // 半角カタカナ
            const zen1 = sys.__getSysVar('全角カナ一覧');
            const han1 = sys.__getSysVar('半角カナ一覧');
            const zen2 = sys.__getSysVar('全角カナ濁音一覧');
            const han2 = sys.__getSysVar('半角カナ濁音一覧');
            let str = '';
            let i = 0;
            while (i < s.length) {
                // 濁点の変換
                const c2 = s.substring(i, i + 2);
                const n2 = han2.indexOf(c2);
                if (n2 >= 0) {
                    str += zen2.charAt(n2 / 2);
                    i += 2;
                    continue;
                }
                // 濁点以外の変換
                const c = s.charAt(i);
                const n = han1.indexOf(c);
                if (n >= 0) {
                    str += zen1.charAt(n);
                    i++;
                    continue;
                }
                str += c;
                i++;
            }
            return str;
        }
    },
    'カタカナ半角変換': {
        type: 'func',
        josi: [['の', 'を']],
        pure: true,
        fn: function (s, sys) {
            // 半角カタカナ
            const zen1 = sys.__getSysVar('全角カナ一覧');
            const han1 = sys.__getSysVar('半角カナ一覧');
            const zen2 = sys.__getSysVar('全角カナ濁音一覧');
            const han2 = sys.__getSysVar('半角カナ濁音一覧');
            return s.split('').map((c) => {
                const i = zen1.indexOf(c);
                if (i >= 0) {
                    return han1.charAt(i);
                }
                const j = zen2.indexOf(c);
                if (j >= 0) {
                    return han2.substring(j * 2, j * 2 + 2);
                }
                return c;
            }).join('');
        }
    },
    '全角変換': {
        type: 'func',
        josi: [['の', 'を']],
        pure: false,
        fn: function (s, sys) {
            let result = s;
            result = sys.__exec('カタカナ全角変換', [result, sys]);
            result = sys.__exec('英数記号全角変換', [result, sys]);
            return result;
        }
    },
    '半角変換': {
        type: 'func',
        josi: [['の', 'を']],
        pure: false,
        fn: function (s, sys) {
            let result = s;
            result = sys.__exec('カタカナ半角変換', [result, sys]);
            result = sys.__exec('英数記号半角変換', [result, sys]);
            return result;
        }
    },
    '全角カナ一覧': { type: 'const', value: 'アイウエオカキクケコサシスセソタチツテトナニヌネノハヒフヘホマミムメモヤユヨラリルレロワヲンァィゥェォャュョッ、。ー「」' }, // @ぜんかくかないちらん
    '全角カナ濁音一覧': { type: 'const', value: 'ガギグゲゴザジズゼゾダヂヅデドバビブベボパピプペポ' }, // @ぜんかくかなだくおんいちらん
    '半角カナ一覧': { type: 'const', value: 'ｱｲｳｴｵｶｷｸｹｺｻｼｽｾｿﾀﾁﾂﾃﾄﾅﾆﾇﾈﾉﾊﾋﾌﾍﾎﾏﾐﾑﾒﾓﾔﾕﾖﾗﾘﾙﾚﾛﾜｦﾝｧｨｩｪｫｬｭｮｯ､｡ｰ｢｣ﾞﾟ' }, // @はんかくかないちらん
    '半角カナ濁音一覧': { type: 'const', value: 'ｶﾞｷﾞｸﾞｹﾞｺﾞｻﾞｼﾞｽﾞｾﾞｿﾞﾀﾞﾁﾞﾂﾞﾃﾞﾄﾞﾊﾞﾋﾞﾌﾞﾍﾞﾎﾞﾊﾟﾋﾟﾌﾟﾍﾟﾎﾟ' }, // @はんかくかなだくおんいちらん
    // @指定形式
    '通貨形式': {
        type: 'func',
        josi: [['を', 'の']],
        pure: true,
        fn: function (v) {
            return String(v).replace(/(?<!\.\d*?)(\d)(?=(\d\d\d)+(?!\d))/g, '$1,');
        }
    },
    'ゼロ埋': {
        type: 'func',
        josi: [['を'], ['で']],
        pure: true,
        fn: function (v, a) {
            v = String(v);
            let z = '0';
            for (let i = 0; i < a; i++) {
                z += '0';
            }
            a = parseInt(a);
            if (a < v.length) {
                a = v.length;
            }
            const s = z + String(v);
            return s.substring(s.length - a, s.length);
        }
    },
    '空白埋': {
        type: 'func',
        josi: [['を'], ['で']],
        pure: true,
        fn: function (v, a) {
            v = String(v);
            let z = ' ';
            for (let i = 0; i < a; i++) {
                z += ' ';
            }
            a = parseInt(a);
            if (a < v.length) {
                a = v.length;
            }
            const s = z + String(v);
            return s.substring(s.length - a, s.length);
        }
    },
    // @文字種類
    'かなか判定': {
        type: 'func',
        josi: [['を', 'の', 'が']],
        pure: true,
        fn: function (s) {
            const c = String(s).charCodeAt(0);
            return (c >= 0x3041 && c <= 0x309F);
        }
    },
    'カタカナ判定': {
        type: 'func',
        josi: [['を', 'の', 'が']],
        pure: true,
        fn: function (s) {
            const c = String(s).charCodeAt(0);
            return (c >= 0x30A1 && c <= 0x30FA);
        }
    },
    '数字判定': {
        type: 'func',
        josi: [['を', 'が']],
        pure: true,
        fn: function (s) {
            const c = String(s).charAt(0);
            return ((c >= '0' && c <= '9') || (c >= '０' && c <= '９'));
        }
    },
    '数列判定': {
        type: 'func',
        josi: [['を', 'が']],
        pure: true,
        fn: function (s) {
            const checkerRE = /^[+\-＋－]?([0-9０-９]*)(([.．][0-9０-９]+)?|([.．][0-9０-９]+[eEｅＥ][+\-＋－]?[0-9０-９]+)?)$/;
            if (s === '') {
                return false;
            } // 空文字列はfalse
            return String(s).match(checkerRE) !== null;
        }
    },
};
